import { useCallback } from "react";
import { Lazy } from "yup";

export const useYupValidationResolver = (validationSchema: Lazy) => {
    return useCallback(
        async (formValues) => {
            try {
                const values = await validationSchema.validate(formValues, {
                    abortEarly: false,
                });

                return {
                    values,
                    errors: {},
                };
            } catch (errors) {
                return {
                    values: {},
                    errors: errors.inner.reduce(
                        // eslint-disable-next-line
                        (allErrors: any, currentError: any) => ({
                            ...allErrors,
                            [currentError.path]: {
                                type: currentError.type ?? "validation",
                                message: currentError.message,
                            },
                        }),
                        {}
                    ),
                };
            }
        },
        [validationSchema]
    );
};
